const isNull = <T>(value: T | null): value is null => value === null;

export default function replaceNull<T>(
    value: T | null,
    replacement = '-'
): T | string {
    return isNull(value) ? replacement : value;
}
